import request from "@/utils/request";

// 列表(主数据列表)
export function loadAppActivityDisplayCompetitionListDataApi(data) {
  return request({
    url: "web/appActivityDisplayCompetition/listData",
    method: "post",
    data
  });
}
// 导出
export function loadAppActivityDisplayCompetitionExportDataApi(data) {
  return request({
    url: "web/appActivityDisplayCompetition/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateAppActivityDisplayCompetitionApi(data) {
  return request({
    url: "web/appActivityDisplayCompetition/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initAppActivityDisplayCompetitionApi(data) {
  return request({
    url: "web/appActivityDisplayCompetition/init",
    method: "post",
    data
  });
}

// 根据条件获取条数
export function findAppActivityDisplayCompetitionCountByConditionApi(data) {
  return request({
    url: "web/appActivityDisplayCompetition/findCountByCondition",
    method: "post",
    data
  });
}

// 根据条件获取用户提交数据
export function findAppActivityDisplayCompetitionInfoListByConditionApi(data) {
  return request({
    url: "web/appActivityDisplayCompetitionInfo/listSelectData",
    method: "post",
    data
  });
}

// 导出用户提交数据
export function exportUserCommitDataApi(data) {
  return request({
    url: "web/appActivityDisplayCompetitionInfo/exportUserCommitData",
    method: "post",
    data
  });
}

// 待审核条数
export function countTodoAuditApi(data) {
  return request({
    url: "web/appActivityDisplayCompetitionInfo/countTodoAudit",
    method: "post",
    data
  });
}

// 批量审核
export function auditBatchApi(data) {
  return request({
    url: "web/appActivityDisplayCompetitionInfo/auditBatch",
    method: "post",
    data
  });
}

// 用户提交数据列表(主数据列表)
export function loadAppActivityDisplayCompetitionInfoListDataApi(data) {
  return request({
    url: "web/appActivityDisplayCompetitionInfo/listData",
    method: "post",
    data
  });
}
// 用户提交数据导出
export function loadAppActivityDisplayCompetitionInfoExportDataApi(data) {
  return request({
    url: "web/appActivityDisplayCompetitionInfo/exportData",
    method: "post",
    data
  });
}